import axiosInstance from "../instance/axiosInstance";

class CabinetsApi {
  static async createCabinet(formData) {
    try {
      const response = await axiosInstance.post("/cabinet/save", formData);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async transferCabinet(formData) {
    try {
      const response = await axiosInstance.post("/cabinet/transfer", formData);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async cabinetsList(page, searchQuery) {
    let url = `/cabinet/list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async tempCabinetsList(page, searchQuery) {
    let url = `cabinet/temporary-list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async tempCabinetsListForOwner(page, searchQuery) {
    let url = `cabinet/temporary-forowner?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async getSingleCabinet(id) {
    try {
      const response = await axiosInstance.get(`/cabinet/single/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async updateCabinetStatus(formData) {
    try {
      const response = await axiosInstance.put(
        "/cabinet/update-status",
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async updateVisibilityStatus(cabinet_id, visibility_for_temp) {
    try {
      const response = await axiosInstance.post(
        "/cabinet/temporary-update-visibility",
        {
          cabinet_id,
          visibility_for_temp,
        }
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async deleteCabinet(id) {
    try {
      const response = await axiosInstance.get(`/cabinet/delete/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async addCabinetRadio() {
    try {
      const response = await axiosInstance.get("/common-settings");
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async cabinteFilesList(id, page, searchQuery) {
    let url = `/cabinet/${id}/files/list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async tempCabinetFilesList(id, page, searchQuery) {
    let url = `/cabinet/${id}/files/temporary-list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async createCabinetFile(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/cabinet/${id}/files/save`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async deleteCabinetFile(id, cabinetFileId) {
    try {
      const response = await axiosInstance.get(
        `/cabinet/${id}/files/delete/${cabinetFileId}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async statusCabinetFile(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/cabinet/${id}/files/update-status`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getCabinetHistory(id) {
    try {
      const response = await axiosInstance.get(`/cabinet/history-detail/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getFileHistory(cabinet_id, fileId) {
    try {
      const response = await axiosInstance.get(
        `cabinet/${cabinet_id}/files/history-detail/${fileId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getCabinetSingleFile(id, cabinetFileId) {
    try {
      const response = await axiosInstance.get(
        `/cabinet/${id}/files/view/${cabinetFileId}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async transferCabinetFile(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/cabinet/${id}/files/transfer`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getArchiveStatusTypes() {
    try {
      const response = await axiosInstance.get("/archive-status-types");
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async getArchiveTypes() {
    try {
      const response = await axiosInstance.get("/archive-types");
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async createArchive(cabinetId, fileId, formData) {
    try {
      const response = await axiosInstance.post(
        `/cabinet/${cabinetId}/files/${fileId}/archive/save`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async getArchivesList(cabinetId, fileId, page, queryParams) {
    const {
      search_status_type,
      search_title,
      search_date_from,
      search_date_to,
    } = queryParams;
    let url = `/cabinet/${cabinetId}/files/${fileId}/archive/list?page=${page}`;

    if (search_status_type || search_status_type === 0) {
      url += `&search_status_type=${search_status_type}`;
    }
    if (search_title) {
      url += `&search_title=${search_title}`;
    }
    if (search_date_from) {
      url += `&search_date_from=${search_date_from}`;
    }
    if (search_date_to) {
      url += `&search_date_to=${search_date_to}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async getTempArchivesList(cabinetId, fileId, page, queryParams) {
    const {
      search_status_type,
      search_title,
      search_date_from,
      search_date_to,
    } = queryParams;
    let url = `/cabinet/${cabinetId}/files/${fileId}/archive/temporary-list?page=${page}`;

    if (search_status_type || search_status_type === 0) {
      url += `&search_status_type=${search_status_type}`;
    }
    if (search_title) {
      url += `&search_title=${search_title}`;
    }
    if (search_date_from) {
      url += `&search_date_from=${search_date_from}`;
    }
    if (search_date_to) {
      url += `&search_date_to=${search_date_to}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteArchive(id, fileId, archiveId) {
    try {
      const response = await axiosInstance.get(
        `/cabinet/${id}/files/${fileId}/archive/delete/${archiveId}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async updateArchiveStatus(id, fileId, formData) {
    try {
      const response = await axiosInstance.put(
        `/cabinet/${id}/files/${fileId}/archive/update-status`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getArchiveHistory(id, fileId, archiveId) {
    try {
      const response = await axiosInstance.get(
        `cabinet/${id}/files/${fileId}/archive/history-detail/${archiveId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async transferArchive(id, fileId, formData) {
    try {
      const response = await axiosInstance.post(`/cabinet/${id}/files/${fileId}/archive/transfer`, formData);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async getSingleArchive(id, fileId, archiveId) {
    try {
      const response = await axiosInstance.get(`/cabinet/${id}/files/${fileId}/archive/view/${archiveId}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async openSingleArchive(id, fileId, archiveId) {
    try {
      const response = await axiosInstance.get(`/cabinet/${id}/files/${fileId}/archive/open/${archiveId}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async checkArchiveLimit() {
    try {
      const response = await axiosInstance.get(`/archive-limit-check`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  // static async downloadArchive(filePath) {
  //   const obj = {
  //     file_path: filePath
  //   }
  //   try {
  //     const response = await axiosInstance.post(`/download`, obj);
      
  //     if (response) return response.data;
  //   } catch (error) {
  //     return error;
  //   }
  // }
  // static async viewArchive(filePath) {
  //   const obj = {
  //     file_path: filePath
  //   }
  //   try {
  //     const response = await axiosInstance.post(`/attachment-view`, obj);
      
  //     if (response) return response.data;
  //   } catch (error) {
  //     return error;
  //   }
  // }

  static async downloadArchive(filePath) {
    try {
      const response = await axiosInstance.post("/get-download-url", {
        file_path: filePath,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async viewArchive(filePath) {
    try {
      const response = await axiosInstance.post("/preview-file", {
        file_path: filePath,
      });
      return {
        url: response.config.url,
        data: response.data,
        message: "File preview available",
      };
    } catch (error) {
      throw error;
    }
  }

  static async getFileInfo(filePath) {
    try {
      const response = await axiosInstance.post("/get-file-info", {
        file_path: filePath,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
  static async checkTempCabinLimit() {
    try {
      const response = await axiosInstance.get(`/temp-cabinet-limit-check`);
      
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default CabinetsApi;
